import { ProductsDataItemType } from "./productsData";


/**
 * 식물재배기 데이터
 */
const productsData_Tiiun: ProductsDataItemType = {
  category: "tiiun",
  ga_id: "indoor_gardening_appliance",
  label: "category_tiiun",
  category_img_url: "/images/products/tiiun/category_img.png",
  category_thumb_url: "/images/products/tiiun/category_thumb.png",
  category_glow_url: "/images/products/tiiun/category_glow.png",
  roomType: "living",
  usp_transition: "/movies/usp/transition/main_REF_000_00000.webm",
  productList: [
    {
      name: "LG tiiun",
      modelNo: "tiiun",
      ga_id: "tiiun",
      isCES: false,
      thumb_url: "/images/products/tiiun/tiiun/product_thumb.png",
      openExperience: false,
      colors: [
        {
          name: <></>,
          label: "home_exp_color_nature_green",
          color: "/images/products/tiiun/tiiun/color_nature_green.png",
          ga_id: "nature_green",
        },
      ],
      // model: <Tiiun />,
    },
  ],
};
export default productsData_Tiiun;
